import locale from "common/managers/locale";
var util = {

    /**
     * Last state set by the util class.  Defaults to false if no state has been set by the util class.
     * True = checked,
     * False = unchecked,
     * null = partial
     * @param check
     */
    lastSetState: function(check) {
        var checkState = $(check).attr("data-check-state");
        if (checkState == "checked") {
            return true;
        } else if (checkState == "partial") {
            return null;
        } else {
            return false;
        }
    },

    /**
     * Determine the next state of checkbox.
     * @param check Checkbox
     * @param forcePartial Should partial state availability be forced.
     */
    nextSetState: function(check, forcePartial) {
        var last = this.lastSetState(check);
        var canGoToPartial = !!forcePartial || !!$(check).attr("data-has-partial");
        if (last === true) {
            //unchecked
            return false;
        } else if (last === false && canGoToPartial) {
            return null;
        } else {
            return true;
        }
    },

    _text: function(check, text) {
        check = $(check);
        var parent = check.parent();
        if (parent.is("td")) {
            parent.attr("aria-label", text);
            check.attr("role", "presentation");
        }
    },

    /**
     * Check a checkbox.
     */
    check: function(check, primary) {
        $(check).prop("indeterminate", false).prop("checked", true).attr('data-check-state', "checked");
        this._text(check, primary?.label && primary?.value ? locale.get("checked.instructions.for.specific", primary.label, primary.value) : locale.get("checked.instructions"));
    },

    /**
     * Uncheck a checkbox.
     */
    uncheck: function(check, primary) {
        $(check).prop("indeterminate", false).prop("checked", false).attr("data-check-state", "unchecked");
        this._text(check, primary?.label && primary?.value ? locale.get("unchecked.instructions.for.specific", primary.label, primary.value) : locale.get("unchecked.instructions"));
    },

    /**
     * Partially check a checkbox.
     */
    partial: function(check) {
        $(check).prop("indeterminate", true).prop("checked", true).attr("data-check-state", "partial").attr("data-has-partial", true);
        this._text(check, locale.get("partially.checked.instructions"));
    }
};
export default util;
